import React from 'react';
import { Link } from 'react-router-dom';
import S from './style';
import TranslateStatic from '../../locales/TranslateStatic';

import YumurtlamaImg from '../../assets/dondurarak.jpeg';
import AsrmEshre from '../../components/asrmEshre';

export function TedaviSureci() {
  return (
    <S.PageWrapper>
      <S.HeroSection>
        <div className="hero-content">
          <h1><TranslateStatic string="TedaviSureci" /></h1>
          <S.Breadcrumb>
            <Link to="/"><TranslateStatic string="home" /></Link>
            <span className="separator">/</span>
            <TranslateStatic string="TedaviSureci" />
          </S.Breadcrumb>
        </div>
      </S.HeroSection>

      <S.ContentWrapper>
        <div className="info-container">
          <div className="image-wrapper">
            <img src={YumurtlamaImg} alt="Tedavi Süreci" />
          </div>

          <div className="date-info">
            <TranslateStatic string="SonGuncellemeTarihi" /> 19.02.2025
          </div>

          <div className="text-content">
            <h3><TranslateStatic string="TedaviSureciH3-1" /></h3>
            <p><TranslateStatic string="TedaviSureciP-1" /></p>
            <p><TranslateStatic string="TedaviSureciP-1-2" /></p>
            <p><TranslateStatic string="TedaviSureciP-1-3" /></p>
            
            <h3><TranslateStatic string="TedaviSureciH3-2" /></h3>
            <p><TranslateStatic string="TedaviSureciP-2" /></p>
            <p><TranslateStatic string="TedaviSureciP-2-1" /></p>
            
            <h3><TranslateStatic string="TedaviSureciH3-3" /></h3>
            <p><TranslateStatic string="TedaviSureciP-3" /></p>
            <p><TranslateStatic string="TedaviSureciP-3-1" /></p>
            <p><TranslateStatic string="TedaviSureciP-3-2" /></p>
          </div>
        </div>

        <AsrmEshre />
      </S.ContentWrapper>
    </S.PageWrapper>
  );
}
